<template>
  <v-dialog v-model="dialog" scrollable>
    <v-card>
      <v-card-title>Настройка региона</v-card-title>
      <v-card-text>
        <v-select
          v-model="item.value"
          :items="valueList"
          item-value="id"
          label="Значение"
        />
        <template v-if="axisLines.length > 0">
          <h3 class="black--text font-weight-medium">Данные для графика</h3>
          <div
            v-for="(item, key) in data"
            :key="key"
            class="d-flex justify-space-between align-center"
          >
            <div>
              <date-picker v-model="item.date" />
            </div>
            <div v-for="(line, lineKey) in axisLines" :key="lineKey">
              <v-text-field v-model="item[line.name]" :label="line.name" />
            </div>
            <div>
              <v-btn class="error" @click="remove(key)">Удалить</v-btn>
            </div>
          </div>
          <div class="d-flex justify-end">
            <v-btn class="success" @click="add">Добавить</v-btn>
          </div>
        </template>

        <v-textarea
          v-model="text"
          label="Доп. текст"
        />

        <div class="d-flex justify-end">
          <v-btn class="success" @click="save">Сохранить</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import DatePicker from '@/components/ui/date-picker';

export default {
  name: 'region-layer-settings-dialog',
  components: { DatePicker },
  mixins: [DialogBusMixin],
  data: () => ({
    text: '',
    axisLines: [],
    data: [],
    item: { value: '' },
    valueList: [],
  }),
  methods: {
    remove(i) {
      this.data.splice(i, 1);
    },

    add() {
      const item = { date: '' };
      this.axisLines.forEach((i) => {
        item[i.name] = null;
      });

      this.data.push(item);
    },

    beforeOpen({ item, single, valueList }) {
      this.item = item;
      this.valueList = valueList;

      if (single.layerSettings) this.axisLines = single.layerSettings.axisLines;

      this.data = item.graphData ? JSON.parse(JSON.stringify(item.graphData)) : [];

      this.text = item.text;
    },

    save() {
      this.$emit('update', {
        value: this.item.value,
        id: this.item.id,
        data: this.data,
        text: this.text,
      });

      this.dialog = false;
    },
  },
};
</script>

<style scoped>

</style>
